export default [
  {
    path: '/info',
    component: () => import('@/views/Info.vue'),
    name: 'info',
    meta: {
      navName: 'info',
      sideNav: true,
      requiresAuth: true
    },
  },

  {
    path: '/info/new',
    component: () => import('@/views/Info/New.vue'),
    name: 'info-new',
    meta: {
      navName: 'info',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/info/:id',
    component: () => import('@/views/Info/Edit.vue'),
    name: 'info-edit',
    meta: {
      navName: 'info',
      sideNav: true,
      requiresAuth: true
    }
  },
]
